/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WarehouseCarrierDTOFromJSON, WarehouseCarrierDTOToJSON, } from './WarehouseCarrierDTO';
/**
 * @export
 */
export const WarehouseMarketCarriersDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the WarehouseMarketCarriersDTO interface.
 */
export function instanceOfWarehouseMarketCarriersDTO(value) {
    return true;
}
export function WarehouseMarketCarriersDTOFromJSON(json) {
    return WarehouseMarketCarriersDTOFromJSONTyped(json, false);
}
export function WarehouseMarketCarriersDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'carriers': json['carriers'] == null ? undefined : (json['carriers'].map(WarehouseCarrierDTOFromJSON)),
    };
}
export function WarehouseMarketCarriersDTOToJSON(json) {
    return WarehouseMarketCarriersDTOToJSONTyped(json, false);
}
export function WarehouseMarketCarriersDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marketplace': value['marketplace'],
        'carriers': value['carriers'] == null ? undefined : (value['carriers'].map(WarehouseCarrierDTOToJSON)),
    };
}
